/**
 * Test IDs for QA automation.
 */
export const testIds = {
  extensionsMessagesOpenAction: "extensions-messages-open-action",
  extensionsMessagesClose: "extensions-messages-close",
} as const;
